export interface SelectField {
  id: string;
  label?: string;
  placeholder?: string;
  tooltip?: string;
  sort?: SelectFieldDataSort;
  addOther?: boolean;
  options: { [key: string]: string };
}

export enum SelectFieldDataSort {
  asInOrder = 'asInOrder',
  valueAscOrder = 'valueAscOrder',
  valueDescOrder = 'valueDescOrder',
}
